import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "@/components/HoldCountdown/HoldCountdown.scss";

interface HoldCountdownProps {
  /** ISO timestamp until which the nights are held. */
  expiresAt: string;
  onExpired: () => void;
}

function remainingSeconds(expiresAt: string): number {
  return Math.max(
    0,
    Math.round((new Date(expiresAt).getTime() - Date.now()) / 1000)
  );
}

/** "Your dates are held for 14:32" — calls onExpired once the hold has run out. */
function HoldCountdown({ expiresAt, onExpired }: HoldCountdownProps) {
  const { t } = useTranslation();
  const [seconds, setSeconds] = useState(() => remainingSeconds(expiresAt));

  useEffect(() => {
    const timer = setInterval(
      () => setSeconds(remainingSeconds(expiresAt)),
      1000
    );
    return () => clearInterval(timer);
  }, [expiresAt]);

  useEffect(() => {
    if (seconds === 0) {
      onExpired();
    }
  }, [seconds, onExpired]);

  const minutes = Math.floor(seconds / 60);
  const rest = String(seconds % 60).padStart(2, "0");

  return (
    <p
      className={`hold-countdown${seconds < 120 ? " hold-countdown--urgent" : ""}`}
      role="timer"
    >
      {t("payment.holdCountdown", { time: `${minutes}:${rest}` })}
    </p>
  );
}

export default HoldCountdown;
export type { HoldCountdownProps };
